import { CLEAR_STATE_DATA, WEB_LOGOUT } from '../action-types/session-actions';

const SET_CUSTOMER = 'SET_CUSTOMER';
const CLEAR_CUSTOMER = 'CLEAR_CUSTOMER';
const SET_ACTIVE_TABLE_ORDER = 'SET_ACTIVE_TABLE_ORDER';
const CLEAR_ACTIVE_TABLE_ORDER = 'CLEAR_ACTIVE_TABLE_ORDER';

const initState = {
    customer: null,
    customerMembership: [],
    active_table_orders: {},
    last_order: {},
    user: {},
    appliedfilters: null,
    clearStatus: null,
    lastOrderList: [],
    capturedImage: null,
    storeInfo: null, // Legacy fallback
    storeInfoConfig: null, // Legacy fallback
};

const reducer = (state = initState, action) => {
    switch (action.type) {
        case 'CUSTOMER_MEMBERSHIP':
            return { ...state, customerMembership: action.customerMembership };
        case SET_CUSTOMER:
            return { ...state, customer: action.customer };
        case CLEAR_CUSTOMER:
            return { ...state, customer: null };
        case SET_ACTIVE_TABLE_ORDER:
            return {
                ...state,
                active_table_orders: {
                    ...state.active_table_orders,
                    [action.payload.tableNo]: {
                        ...state.active_table_orders[action.payload.tableNo],
                        ...action.payload.data
                    }
                }
            };
        case CLEAR_ACTIVE_TABLE_ORDER: {
            const nextActiveTableOrders = { ...state.active_table_orders };
            if (action.payload?.tableNo) {
                delete nextActiveTableOrders[action.payload.tableNo];
            } else {
                return { ...state, active_table_orders: {} };
            }
            return { ...state, active_table_orders: nextActiveTableOrders };
        }
        
        case 'FILTERS':
            // Removed legacy appliedfilters
            return state;
        case 'SET_LAST_ORDER':
            return { ...state, last_order: action.last_order };
        case 'CLEAR_LAST_ORDER':
            return { ...state, last_order: null };
        case 'STORE_DETAILS':
        case 'GET_STORE_DETAILS':
            // Removed legacy storeInfo
            return state;
        case 'STORE_CONFIG':
        case 'GET_STORE_CONFIG':
            // Removed legacy storeInfoConfig
            return state;
        case 'SET_USER':
            return { ...state, user: action.user };
        case 'LAST_ORDER_LIST':
            return { ...state, lastOrderList: action.lastOrderList };
        case 'CAPTURED_IMAGE':
            return { ...state, capturedImage: action.capturedImage };

        case WEB_LOGOUT:
        case CLEAR_STATE_DATA:
            return { ...initState };
        default:
            return state;
    }
};

export default reducer;
